import { optionSubcategory_notifications } from 'owa-locstrings/lib/strings/optionsubcategory_notifications.locstring.json';
import { NotificationsOptions } from 'owa-notifications-option';
import { OptionSubCategory } from 'owa-options-core';
import { SkypeNotificationOption } from 'owa-skype-option';
import AppNotificationsOption from 'owa-app-notifications-option/lib/AppNotificationsOption';
import { ActionConfirmationsOption } from 'owa-action-confirmations-option';

let notificationsSubCategory: OptionSubCategory = {
    key: 'notifications',
    titleStringKey: optionSubcategory_notifications,
    options: [
        AppNotificationsOption,
        NotificationsOptions,
        SkypeNotificationOption,
        ActionConfirmationsOption,
    ],
};

export default notificationsSubCategory;
